<template>
    <v-card height="100">
        <v-card-text>
            <h2>Billing</h2>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    name: "account-billing",
    data() {
        return {};
    },
};
</script>